import 'maplibre-gl/dist/maplibre-gl.css';

import {AppParamsContext} from 'contexts/AppParamsContext';
import {RMap, RMarker, RPopup, useMap} from 'maplibre-react-components';
import {useContext, useEffect, useState} from 'react';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import {useDictionary} from '@adamlip/okeoke.client';
import mapStyle from './mapStyle.json';
const MapHandler = ({selectedLocation, locations, handleLocationChange}) => {
	const map = useMap('map');
	if (!map) return null;

	if (selectedLocation && locations?.[selectedLocation]?.geolocation) {
		map.flyTo({
			center: [locations?.[selectedLocation]?.geolocation?.lng, locations?.[selectedLocation]?.geolocation?.lat],
			zoom: 15,
		});
	}
};
function MapRender({centerCoords, locations, selectedLocation, handleLocationChange}) {
	const {appParams} = useContext(AppParamsContext);
	const {getValue} = useDictionary();
	const iconURL = appParams?.assets?.mapMarker || 'https://cdn.okeoke.io/global/assets/marker.png';
	const [clickedLocation, setClickedLocation] = useState(null);

	useEffect(() => {
		if (selectedLocation) {
			setClickedLocation(null);
		}
	}, [selectedLocation]);
	if (!centerCoords) return null;
	return (
		<>
			<RMap id='map' minZoom={0} initialCenter={[centerCoords[1], centerCoords[0]]} initialZoom={13} mapStyle={mapStyle}>
				<MapHandler selectedLocation={clickedLocation ? clickedLocation : selectedLocation} locations={locations} handleLocationChange={handleLocationChange} />
				{Object.values(locations || {})
					?.filter((location) => location.enabled && location.geolocation?.lat && location.geolocation?.lng)
					?.map((location) => (
						<RMarker key={location.uuid} longitude={location.geolocation.lng} latitude={location.geolocation.lat}>
							<img src={iconURL} alt='marker' className='w-10 cursor-pointer h-10' onClick={() => setClickedLocation(location.uuid)} />
							{clickedLocation === location.uuid && (
								<RPopup longitude={location.geolocation.lng} latitude={location.geolocation.lat} className='rounded-xl'>
									<div className='p-1 flex flex-col gap-0 min-w-[150px]'>
										<div className='font-bold '>{location?.name}</div>

										<div className='text-xs pb-2'>{`${location.address?.city !== '' ? location.address?.city + ', ' : ''} ${location.address.zip} ${location.address.street} ${location.address.streetNumber}`}</div>

										<BarSoftButton forceCustom={true} color='primary' size='sm' radius='full' onPress={() => handleLocationChange(location.uuid, true)}>
											{getValue('app_v2_orderFromHere')}
										</BarSoftButton>
									</div>
								</RPopup>
							)}
						</RMarker>
					))}
			</RMap>
		</>
	);
}

export default MapRender;
